import { BaseModalV2 } from 'components/ui/BaseModal'
import { ConversationFooter } from './ConversationFooter'
import { ConversationHeader } from './ConversationHeader'
import { ConversationBody } from './ConversationBody'
import React from 'react'
import { IPop, RootState } from 'constants/interfaces'
import { useUserName } from 'hooks/useUserName'
import strings from 'constants/strings'
import { useSelector } from 'react-redux'

export interface ConversationMessage {
  message: string
  isUserMessage?: boolean
  isFakeMessage?: boolean
}

interface IProps {
  isOpen: boolean
  onClose: () => void
  conversation: ConversationMessage[]
  isBotResponseInProgress: boolean
  isWebSocketReady: boolean
  onSendMessage: (message: string) => void
  onClearHistory?: () => void
  onReconnect?: () => void
  hasWebSocketError?: boolean
  pop?: IPop
  isLoading?: boolean
  isInstantConversation?: boolean
  isSessionExpired?: boolean
  onReloadSession?: () => void
  setIsPlaying: (isPlaying: boolean) => void
  isPlaying: boolean
  onStopVoicePlayback?: () => void
}

export const ConversationModal = ({
  isOpen,
  onClose,
  conversation,
  isBotResponseInProgress,
  isWebSocketReady,
  onSendMessage,
  onReconnect,
  hasWebSocketError = false,
  pop,
  isLoading,
  isInstantConversation = false,
  isSessionExpired = false,
  onReloadSession,
  setIsPlaying,
  isPlaying,
  onStopVoicePlayback,
}: IProps) => {
  const userName = useUserName(pop?.created_by || '')
  const { isReportLoading } = useSelector((state: RootState) => state.reports)
  const title = userName.trim() ? userName : strings.COMPANY_NAME
  return (
    <BaseModalV2
      modalContentProps={{
        borderRadius: '20px',
        width: '100%',
        maxW: '600px',
      }}
      modalHeaderProps={{
        boxShadow: 'none',
      }}
      modalBodyProps={{
        px: '5px',
        py: '0px',
        backgroundColor: 'white',
        maxH: isInstantConversation ? '70vh' : '80vh',
      }}
      isOpen={isOpen}
      onClose={onClose}
      header={
        <ConversationHeader
          onClose={onClose}
          title={title}
          isInstantConversation={isInstantConversation}
          setIsPlaying={setIsPlaying}
          isPlaying={isPlaying}
        />
      }
      body={
        <ConversationBody
          conversation={conversation}
          isBotResponseInProgress={isBotResponseInProgress}
          isWebSocketReady={isWebSocketReady}
          onReconnect={onReconnect}
          hasWebSocketError={hasWebSocketError}
          pop={pop}
          isLoading={isLoading || isReportLoading}
          isSessionExpired={isSessionExpired}
          onReloadSession={onReloadSession}
        />
      }
      footer={
        <ConversationFooter
          onSend={onSendMessage}
          disabled={isBotResponseInProgress || isSessionExpired}
          onStopVoicePlayback={onStopVoicePlayback}
        />
      }
    />
  )
}
